// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq {
  position: relative;
  padding: 30px 85px;
  background-color: #ffffff;
}

.faq .faq-image {
  width: 100px;
}

.faq img {
  width: 90%;
}

.faq-desc-text {
  color: #868383;
  font-weight: 100;
}

.faq-desc-heading {
  color: #27448a;
  font-size: 32px;
  font-weight: 600;
  margin-top: 30px;
}

#accordion {
  text-align: left;
  margin: 80px 0px 80px 70px;
}

#accordion input {
  display: none;
}

#accordion input[type="radio"]:checked + .content .answer {
  max-height: 300px;
}

#accordion input[type="radio"]:checked + .content .question {
  font-weight: 600;
  color: hsl(238, 29%, 16%);
}

.faq--body {
  border-bottom: solid 2px hsl(240, 5%, 91%);
  padding: 25px 0px;
}

.question {
  display: flex;
  font-size: 18px;
  font-weight: 500;
  padding: 2px;
  color: #0d0d0d;
}

.question:hover {
  color: #3b3b3b;
}

#accordion .answer {
  overflow: hidden;
  max-height: 0;
  cursor: pointer;
  transition: max-height 0.3s;
  color: hsl(240, 6%, 50%);
  font-size: 13px;
}

#accordion .answer a {
  text-decoration: none;
  color: #2a2f5c;
  font-weight: 300;
}

#accordion .answer a:hover {
  color: blue;
}

.faq .fa-solid {
  margin-left: auto;
  padding-right: 15px;
  font-size: 12px;
}

#accordion input[type="radio"]:checked + .content .fa-solid {
  transform: rotate(180deg);
  cursor: pointer;
  padding-left: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/view/landing/Faq.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".faq {\n  position: relative;\n  padding: 30px 85px;\n  background-color: #ffffff;\n}\n\n.faq .faq-image {\n  width: 100px;\n}\n\n.faq img {\n  width: 90%;\n}\n\n.faq-desc-text {\n  color: #868383;\n  font-weight: 100;\n}\n\n.faq-desc-heading {\n  color: #27448a;\n  font-size: 32px;\n  font-weight: 600;\n  margin-top: 30px;\n}\n\n#accordion {\n  text-align: left;\n  margin: 80px 0px 80px 70px;\n}\n\n#accordion input {\n  display: none;\n}\n\n#accordion input[type=\"radio\"]:checked + .content .answer {\n  max-height: 300px;\n}\n\n#accordion input[type=\"radio\"]:checked + .content .question {\n  font-weight: 600;\n  color: hsl(238, 29%, 16%);\n}\n\n.faq--body {\n  border-bottom: solid 2px hsl(240, 5%, 91%);\n  padding: 25px 0px;\n}\n\n.question {\n  display: flex;\n  font-size: 18px;\n  font-weight: 500;\n  padding: 2px;\n  color: #0d0d0d;\n}\n\n.question:hover {\n  color: #3b3b3b;\n}\n\n#accordion .answer {\n  overflow: hidden;\n  max-height: 0;\n  cursor: pointer;\n  transition: max-height 0.3s;\n  color: hsl(240, 6%, 50%);\n  font-size: 13px;\n}\n\n#accordion .answer a {\n  text-decoration: none;\n  color: #2a2f5c;\n  font-weight: 300;\n}\n\n#accordion .answer a:hover {\n  color: blue;\n}\n\n.faq .fa-solid {\n  margin-left: auto;\n  padding-right: 15px;\n  font-size: 12px;\n}\n\n#accordion input[type=\"radio\"]:checked + .content .fa-solid {\n  transform: rotate(180deg);\n  cursor: pointer;\n  padding-left: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
